import { Group, Stack } from '@mantine/core';
import { useViewportSize } from '@mantine/hooks';
import { useCompanyConfiguration } from 'init/use-company-configuration';
import { CustomVariablesPanel } from './CustomVariablesPanel';
import { PreferencePanel } from './PreferencePanel';
import { TncPanel } from './TncPanel';

export const PreferenceTab = () => {
  const company = useCompanyConfiguration();
  const { width } = useViewportSize();

  // Would love to avoid having a magic number here but couldn't find a better way
  const shouldStack = width <= 1400;

  return (
    <Stack mt="sm">
      {shouldStack ? (
        <Stack>
          <PreferencePanel />
          {company?.package?.can_use_custom_variables && <CustomVariablesPanel />}
        </Stack>
      ) : (
        <Group align="stretch" grow>
          <PreferencePanel />
          {company?.package?.can_use_custom_variables && <CustomVariablesPanel />}
        </Group>
      )}
      <TncPanel />
    </Stack>
  );
};
